<template>
  <b-modal v-bind:id="id"
          class="learning-guide-modal"
          ref="modal"
          centered
          hide-header
          hide-footer>
    <slot>
      <div class="score-guide-container">
        <div class="score-guide-header">{{ $t('ct_score.title') }}</div>
        <div class="score-guide-article" v-html="$t('ct_score.description')">
        </div>
        <div class="standard-container">
          <div class="standard-article" v-for="item in gradeScores" :key="item.grade">
            <div class="grade">{{ item.grade }}</div>
            <div class="score">{{ item.score }}</div>
          </div>
        </div>
        <div class="button-container">
          <button type="button" @click="handleSubmit">{{ $t('ct_score.score_confirm') }}</button>
        </div>
      </div>
    </slot>
  </b-modal>
</template>

<script>
  export default {
    name: 'cat-score-guide',

    props: {
      id: String,
    },

    data() {
      return {
        gradeScores: [
          { grade: this.$t('ct_score.score_label_1'), score: this.$t('ct_score.score_value_1') },
          { grade: this.$t('ct_score.score_label_2'), score: this.$t('ct_score.score_value_2') },
          { grade: this.$t('ct_score.score_label_3'), score: this.$t('ct_score.score_value_3') },
          { grade: this.$t('ct_score.score_label_4'), score: this.$t('ct_score.score_value_4') },
          { grade: this.$t('ct_score.score_label_5'), score: this.$t('ct_score.score_value_5') },
          { grade: this.$t('ct_score.score_label_6'), score: this.$t('ct_score.score_value_6') },
          { grade: this.$t('ct_score.score_label_7'), score: this.$t('ct_score.score_value_7') },
          { grade: this.$t('ct_score.score_label_8'), score: this.$t('ct_score.score_value_8') },
          { grade: this.$t('ct_score.score_label_9'), score: this.$t('ct_score.score_value_9') },
          { grade: this.$t('ct_score.score_label_10'), score: this.$t('ct_score.score_value_10') },
          { grade: this.$t('ct_score.score_label_11'), score: this.$t('ct_score.score_value_11') },
          { grade: this.$t('ct_score.score_label_12'), score: this.$t('ct_score.score_value_12') },
        ],
      };
    },

    methods: {
      handleSubmit() {
        this.$refs.modal.hide();
      },
    },
  };
</script>

<style lang="scss" scoped>

  .score-guide-container {
    position: relative;
    background: url('/static/images/bg-my-level-info.png') center center;
    background-repeat: no-repeat;
    background-size: cover;

    .score-guide-header {
      color: #00c896;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      padding: 46px;
    }

    .score-guide-article {
      font-size: 16px;
      text-align: center;
      color: rgba(0, 0, 0, 0.87);
    }

    .standard-container {
      text-align: center;
      padding-top: 14px;

      .standard-article {

        .grade {
          display: inline-block;
          font-size: 14px;
          line-height: 1.86;
          color: rgba(0, 0, 0, 0.54);
          padding: 8px;
          width: 40%;
        }

        .score {
          display: inline-block;
          font-size: 14px;
          font-weight: bold;
          color: #00c896;
          padding: 8px;
          width: 30%;
        }
      }
    }

    .button-container {
      text-align: center;
      padding: 24px 0 44px 0px;

      button {
        border-radius: 4px;
        background-color: #00c896;
        color: #ffffff;
        border: 0;
        padding: 2% 22%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CatScoreGuide.vue?765d5c9f